<template>
  <sidenav :orientation="orientation" :class="curClasses">

    <!-- Brand demo (see src/demo.css) -->
    <div class="app-brand demo" v-if="orientation !== 'horizontal'">
      <span class="app-brand-logo demo bg-transparent">
        <img :src="`${publicUrl}asset/img/logo/logo-black.png`" alt="SIPAMER"/>
      </span>
      <!-- <router-link to="/" class="app-brand-text demo sidenav-text font-weight-normal ml-2">SIPAMER</router-link> -->
      <a href="javascript:void(0)" class="layout-sidenav-toggle sidenav-link text-large ml-auto" @click="toggleSidenav()">
        <i class="ion ion-md-menu align-middle"></i>
      </a>
    </div>


    <!-- Links -->


        <!-- <template slot="link-text">Pages</template> -->
        <Administrator/>
        <BranchAdminKabupaten/>
        <BranchAdminProvinsi/>
        <Pelapor/>
        <AgentWMS/>


  </sidenav>
</template>

<script>
import { Sidenav, SidenavLink, SidenavRouterLink, SidenavMenu, SidenavHeader, SidenavBlock, SidenavDivider } from '@/vendor/libs/sidenav'
import Administrator from '@/layout/Role/Sidenav/Administrator'
import BranchAdminKabupaten from '@/layout/Role/Sidenav/BranchAdminKabupaten'
import BranchAdminProvinsi from '@/layout/Role/Sidenav/BranchAdminProvinsi'
import Pelapor from '@/layout/Role/Sidenav/Pelapor'
import AgentWMS from '@/layout/Role/Sidenav/AgentWMS'


export default {
  name: 'app-layout-sidenav',
  components: {
    /* eslint-disable vue/no-unused-components */
    Sidenav,
    SidenavLink,
    SidenavRouterLink,
    SidenavMenu,
    SidenavHeader,
    SidenavBlock,
    SidenavDivider,
    Administrator,
    BranchAdminKabupaten,
    BranchAdminProvinsi,
    Pelapor,
    AgentWMS,
    /* eslint-enable vue/no-unused-components */
  },

  props: {
    orientation: {
      type: String,
      default: 'vertical'
    }
  },

  computed: {
    curClasses () {
      let bg = this.layoutSidenavBg

      if (this.orientation === 'horizontal' && (bg.indexOf(' sidenav-dark') !== -1 || bg.indexOf(' sidenav-light') !== -1)) {
        bg = bg
          .replace(' sidenav-dark', '')
          .replace(' sidenav-light', '')
          .replace('-darker', '')
          .replace('-dark', '')
      }

      return `bg-${bg} ` + (
        this.orientation !== 'horizontal'
          ? 'layout-sidenav'
          : 'layout-sidenav-horizontal container-p-x flex-grow-0'
      )
    }
  },

  methods: {
    isMenuActive (url) {
      return this.$route.path.indexOf(url) === 0
    },

    isMenuOpen (url) {
      return this.$route.path.indexOf(url) === 0 && this.orientation !== 'horizontal'
    },

    toggleSidenav () {
      this.layoutHelpers.toggleCollapsed()
    }
  }
}
</script>
